<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    class="carpo-form demo-ruleForm"
  >
    <VehicleSelect
      prop="customer_vehicle"
      :model="ruleForm.customer_vehicle"
      @update="vehicleChange($event)"
      :disabled="ruleForm.disabled"
    />

    <div
      v-if="tableData.results.length"
      class="flex items-start lg:col-span-3 justify-end"
    >
      <el-button
        :loading="isDownloadLoading"
        type="primary"
        @click="downloadReport()"
      >
        {{ $t('DOWNLOAD_REPORT') }}
      </el-button>
    </div>
  </el-form>
</template>
<script>
import {
  vehicleHistory,
  hardwareHistory,
  stopsHistory,
  exportHardwareHistory,
  exportVehicleHistory,
} from '@/api/reports'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
export default {
  props: ['type'],
  components: {
    VehicleSelect,
  },
  data() {
    return {
      isDownloadLoading: false,
      tableData: {
        results: [],
      },
      cars: [],
      loading: true,
      formLoading: false,
      selectedId: null,

      ruleForm: {
        price: '',
        customer_vehicle: null,
      },

      rules: {
        customer_vehicle: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('SERVICE_TYPE'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    downloadReport() {
      this.isDownloadLoading = true

      var dispatchFunc =
        this.type == 'hardware' ? exportHardwareHistory : exportVehicleHistory

      let actionPayload = this.ruleForm.customer_vehicle

      dispatchFunc
        .api(actionPayload)
        .then((res) => {
          this.isDownloadLoading = false
          if (res) {
            var blob = new Blob([res], { type: 'application/octet-stream' })

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = `history-${this.type}-report-CARPO.xlsx`
            document.body.appendChild(a)
            a.click()

            window.URL.revokeObjectURL(url)
          }
        })
        .catch((error) => {
          console.error('Download Error:', error)
        })
    },
    vehicleChange(id) {
      this.ruleForm.customer_vehicle = id
      if (this.ruleForm.customer_vehicle) {
        this.$route.query.p != undefined
          ? this.$router.replace({ query: null })
          : ''
        this.$emit('vehicleId', id)
        this.$emit('tableLoading', true)
        if (this.selectedId == null) this.loading = true
        this.selectedId = id
        let type_ = ''
        switch (this.type) {
          case 'hardware':
            type_ = hardwareHistory
            break
          case 'driver':
            type_ = vehicleHistory
            break
          case 'stops':
            type_ = stopsHistory
            break
        }
        // let type_ = this.type == "hardware" ? hardwareHistory : vehicleHistory;
        this.formLoading = true
        type_.api(id).then((res) => {
          if (res) {
            this.tableData.results = res.results
            this.$emit('tableData', res)
            this.$emit('tableLoading', false)
            this.formLoading = false
            this.loading = false
          }
        })
      } else {
        this.$emit('tableData', {
          results: [],
        })
        this.tableData.results = []
      }
    },
  },
  mounted() {
    // carsListSummary.api().then((res) => {
    //   if (res) {
    //     this.cars = res;
    //     this.loading = false;
    //   }
    // });
    // licenseChars.api().then((res) => {
    //   this.alphaList = res;
    // });
  },
}
</script>
